import { EmbeddedMessagePosition } from '../message-position.types';
import { BaseMessageDOM } from './base-message-dom';

export class EmbeddedMessageDOM extends BaseMessageDOM implements MessageDOM {
  protected declare position: EmbeddedMessagePosition;

  public get isReady(): boolean {
    if (!this.buildDomComplete) return false;

    // Message should not be showable if its positioning target cannnot be found
    if (!this.positionTargetElement) {
      console.warn(`Target element not found: ${this.position.target_css_selector}`);
      return false;
    }

    return true;
  }

  public show(): void {
    if (this.el == null) return;

    if (!this.positionTargetElement) {
      // サプライヤのサイトで動的に要素が消えても ErrorNotifier は使わない
      return;
    }

    this.positionTargetElement.insertAdjacentElement(this.position.placement as InsertPosition, this.el);
  }

  // same as EmbeddedMesasgeDOM
  private get positionTargetElement(): HTMLElement | null {
    if (!this.position.target_css_selector) return null;

    try {
      return document.querySelector(this.position.target_css_selector) as HTMLElement;
    } catch (e) {
      console.warn(e);
      return null;
    }
  }
}
